const calculateCPFChecksum = (numericCPF: string, factor: number): number => {
  let sum = 0;
  for (let i = 0; i < factor; i++) {
    sum += parseInt(numericCPF.charAt(i)) * (factor + 1 - i);
  }
  let remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  return remainder;
}

const validateCPF = (cpf: string): boolean => {
  const numericCPF = cpf.replace(/\D/g, '');

  if (numericCPF.length !== 11) {
    return false;
  }

  if (/^(\d)\1{10}$/.test(numericCPF)) {
    return false;
  }

  const firstChecksum = calculateCPFChecksum(numericCPF, 9);
  if (firstChecksum !== parseInt(numericCPF.charAt(9))) {
    return false;
  }

  const secondChecksum = calculateCPFChecksum(numericCPF, 10);
  if (secondChecksum !== parseInt(numericCPF.charAt(10))) {
    return false;
  }

  return true;
}

export default validateCPF;